import httpService from '@/app/arch/services/HttpService';

export default class ShortlistRequest {
  static baseUrl() {
    return '/account';
  }

  static url() {
    return this.baseUrl();
  }

  static history(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/legal-search-history`,
      {
        params,
      },
    );
  }

  static searchOfac(document) {
    return httpService.get(
      `${this.baseUrl()}/shortlist/ofac`,
      {
        params: {
          Document: document,
        },
      },
    );
  }

  static searchCsnu(document) {
    return httpService.get(
      `${this.baseUrl()}/shortlist/csnu`,
      {
        params: {
          Document: document,
        },
      },
    );
  }
}
